import React from 'react'
import { Formik } from 'formik'
import { Divider, Button, Form, Col, Row, Tabs } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as SocioCrud from 'services/socio.service'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import TiposDeDocumentoIdentificacionConstant from 'constants/tiposDeDocumentoIdentificacion'
import ListaDePaisesConstant from 'constants/listaDePaises'

import { ValidationSchema } from '../../_shared/validation'

import { RetrocederButton } from 'sharedComponents/buttons'

import CodigoFormGroup from './formGroups/codigo'
import TipoFormGroup from '../../_shared/formGroups/tipo'
import TipoDocumentoFormGroup from '../../_shared/formGroups/tipoDocumento'
import NumeroDocumentoFormGroup from '../../_shared/formGroups/numeroDocumento'
import RazonSocialFormGroup from '../../_shared/formGroups/razonSocial'
import NombresFormGroup from '../../_shared/formGroups/nombres'
import CuentaCorrienteDolaresFormGroup from '../../_shared/formGroups/cuentaCorrienteDolares'
import CuentaCorrienteSolesFormGroup from '../../_shared/formGroups/cuentaCorrienteSoles'
import ApellidosFormGroup from '../../_shared/formGroups/apellidos'
import IdPaisFormGroup from '../../_shared/formGroups/idPais'
import IdDepartamentoFormGroup from '../../_shared/formGroups/idDepartamento'
import IdProvinciaFormGroup from '../../_shared/formGroups/idProvincia'
import IdDistritoFormGroup from '../../_shared/formGroups/idDistrito'
import ComentarioFormGroup from '../../_shared/formGroups/comentario'
import FormaDePagoSunatFormGroup from '../../_shared/formGroups/formaDePagoSunat'
import CondicionesDePagoFormGroup from '../../_shared/formGroups/condicionesDePago'
import MonedaFormGroup from '../../_shared/formGroups/moneda'
import MonedaLimiteCreditoFormGroup from '../../_shared/formGroups/monedaLimiteCredito'
import LimiteCreditoFormGroup from '../../_shared/formGroups/limiteCredito'
import FlagAgentePercepcionFormGroup from '../../_shared/formGroups/flagAgentePercepcion'
import FlagAgenteRetencionFormGroup from '../../_shared/formGroups/flagAgenteRetencion'
import FlagBuenContribuidorFormGroup from '../../_shared/formGroups/flagBuenContribuidor'
import FacturacionConIgvFormGroup from '../../_shared/formGroups/facturacionConIgv'

import ContactosSection from '../../_shared/sections/contactos'
import DireccionesSection from '../../_shared/sections/direcciones'
import PlacasSection from '../../_shared/sections/placas'
import DocumentosSection from '../../_shared/sections/documentos'
import { IdGen } from 'utils'
import { useHistory } from 'react-router-dom'

const commonReducer = (state, action) => {
  switch (action.type) {
    case 'agregar': {
      const newState = [
        ...state,
        {
          ...action.payload,
          _idFila: IdGen.newId()
        }
      ]
      return newState
    }
    case 'actualizar': {
      const newState = state.map(val => {
        if (val._idFila === action.payload._idFila) {
          val = {
            ...val,
            ...action.payload
          }
        }
        return val
      })
      return newState
    }
    case 'eliminar':
      return state.filter(val => val._idFila !== action.payload._idFila)
    default:
      return state
  }
}

const NuevoMainForm = ({ editarData }) => {
  const __zariContext = React.useContext(ZariContext)

  const history = useHistory()

  const [contactos, contactosDispatcher] = React.useReducer(commonReducer, editarData.contactos, inputArr => {
    if (inputArr) {
      return inputArr.map(x => {
        return {
          ...x,
          _idFila: IdGen.newId()
        }
      })
    }
    return []
  })
  const [direcciones, direccionesDispatcher] = React.useReducer(commonReducer, editarData.direcciones, inputArr => {
    if (inputArr) {
      return inputArr.map(x => {
        return {
          ...x,
          _idFila: IdGen.newId()
        }
      })
    }
    return []
  })

  const [placas, placasDispatcher] = React.useReducer(commonReducer, editarData.placas, inputArr => {
    if (inputArr) {
      return inputArr.map(x => {
        return {
          ...x,
          _idFila: IdGen.newId()
        }
      })
    }
    return []
  })

  const [documentos, documentosDispatcher] = React.useReducer(commonReducer, [], () => [])
  const documentosLoadedRef = React.useRef(false)

  React.useEffect(() => {
    if (!editarData._id || documentosLoadedRef.current) return
    documentosLoadedRef.current = true
    SocioCrud.obtenerDocumentosxIdSocio(editarData._id)
      .then(({ data }) => {
        ;(data || []).forEach(doc => {
          documentosDispatcher({ type: 'agregar', payload: doc })
        })
      })
      .catch(() => {})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editarData._id])

  const formInitialValues = React.useMemo(
    () => ({
      tipo: editarData.tipo || '',
      codigo: editarData.codigo || '',
      tipoDocumento: editarData.tipoDocumento || '',
      numeroDocumento: editarData.numeroDocumento || '',
      razonSocial: editarData.razonSocial || '',
      nombres: editarData.nombres || '',
      apellidos: editarData.apellidos || '',
      direccion: editarData.direccion || '',
      _idPais: editarData._idPais || '',
      _idDepartamento: editarData._idDepartamento || '',
      _idProvincia: editarData._idProvincia || '',
      _idDistrito: editarData._idDistrito || '',
      comentario: editarData.comentario || '',
      _idFormaDePagoSunat: editarData._idFormaDePagoSunat || '',
      _idCondicionDePago: editarData._idCondicionDePago || '',
      moneda: editarData.moneda || '',
      monedaLimiteCredito: editarData.monedaLimiteCredito || '',
      limiteCredito: editarData.limiteCredito || 0,
      flagAgentePercepcion: editarData.flagAgentePercepcion || false,
      flagAgenteRetencion: editarData.flagAgenteRetencion || false,
      flagBuenContribuidor: editarData.flagBuenContribuidor || false,
      facturacionConIgv: editarData.facturacionConIgv || false,
      cuentaCorrienteDolares: editarData.cuentaCorrienteDolares || '',
      cuentaCorrienteSoles: editarData.cuentaCorrienteSoles || ''
    }),
    [editarData]
  )

  const subirDocumentosPendientes = async idSocio => {
    const pendientes = documentos.filter(d => d.pendiente && d.file)
    for (const doc of pendientes) {
      try {
        await SocioCrud.agregarDocumentoxIdSocio(idSocio, {
          tipo: doc.tipo,
          file: doc.file,
          comentario: doc.comentario
        })
      } catch (err) {
        const error = err && err.data && err.data.error
        __zariContext.snack('error', `No se pudo subir "${doc.nombreArchivo}": ${error || 'error desconocido'}`)
      }
    }
  }

  const submitHandler = async data => {
    if (editarData._id) {
      await SocioCrud.actualizarSocio(editarData._id, {
        ...editarData,
        ...data,
        contactos: contactos.map(({ _idFila, ...val }) => val),
        direcciones: direcciones.map(({ _idFila, ...val }) => val),
        placas: placas.map(({ _idFila, ...val }) => val)
      })
        .then(async () => {
          await subirDocumentosPendientes(editarData._id)
          history.push(`/${CodigosTransaccionesConstant.SOCIOS_LISTA}`)
          __zariContext.snack('success', 'El registro se ha actualizado')
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      await SocioCrud.nuevoSocio({
        ...data,
        contactos: contactos.map(({ _idFila, ...val }) => val),
        direcciones: direcciones.map(({ _idFila, ...val }) => val),
        placas: placas.map(({ _idFila, ...val }) => val)
      })
        .then(async ({ data: respData }) => {
          const idNuevo = respData?._id
          if (idNuevo) {
            await subirDocumentosPendientes(idNuevo)
          }
          history.push(`/${CodigosTransaccionesConstant.SOCIOS_LISTA}`)
          __zariContext.snack('success', 'El registro se ha agregado.')
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }

  return (
    <Row>
      <Col md={12}>
        <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
          {({ errors, handleChange, handleSubmit, isSubmitting, setValues, touched, values }) => (
            <Form>
              <Divider title='Información Básica' noMargin />
              <Row>
                <Col md={6}>
                  <TipoFormGroup iError={errors.tipo} iTouched={touched.tipo} fIsSubmitting={isSubmitting} />
                </Col>
                <Col md={6}>
                  <CodigoFormGroup
                    values={values}
                    setValues={setValues}
                    iError={errors.codigo}
                    iTouched={touched.codigo}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <TipoDocumentoFormGroup iError={errors.tipoDocumento} iTouched={touched.tipoDocumento} fIsSubmitting={isSubmitting} />
                </Col>
                <Col md={6}>
                  <NumeroDocumentoFormGroup iError={errors.numeroDocumento} iTouched={touched.numeroDocumento} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
              {values.tipoDocumento === TiposDeDocumentoIdentificacionConstant.DNI ? (
                <Row>
                  <Col md={6}>
                    <NombresFormGroup iError={errors.nombres} iTouched={touched.nombres} fIsSubmitting={isSubmitting} />
                  </Col>
                  <Col md={6}>
                    <ApellidosFormGroup iError={errors.apellidos} iTouched={touched.apellidos} fIsSubmitting={isSubmitting} />
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col md={12}>
                    <RazonSocialFormGroup iError={errors.razonSocial} iTouched={touched.razonSocial} fIsSubmitting={isSubmitting} />
                  </Col>
                </Row>
              )}
              <Row>
                <Col md={6}>
                  <IdPaisFormGroup
                    values={values}
                    setValues={setValues}
                    handleChange={handleChange}
                    iError={errors._idPais}
                    iTouched={touched._idPais}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
                {values._idPais === ListaDePaisesConstant.PERU.ISO2 ? (
                  <>
                    <Col md={6}>
                      <IdDepartamentoFormGroup
                        values={values}
                        setValues={setValues}
                        handleChange={handleChange}
                        iError={errors._idDepartamento}
                        iTouched={touched._idDepartamento}
                        fIsSubmitting={isSubmitting}
                      />
                    </Col>
                    <Col md={6}>
                      <IdProvinciaFormGroup
                        values={values}
                        setValues={setValues}
                        handleChange={handleChange}
                        idDepartamento={values._idDepartamento}
                        iError={errors._idProvincia}
                        iTouched={touched._idProvincia}
                        fIsSubmitting={isSubmitting}
                      />
                    </Col>
                    <Col md={6}>
                      <IdDistritoFormGroup
                        values={values}
                        idProvincia={values._idProvincia}
                        iError={errors._idDistrito}
                        iTouched={touched._idDistrito}
                        fIsSubmitting={isSubmitting}
                      />
                    </Col>
                  </>
                ) : null}
              </Row>
              <ComentarioFormGroup iError={errors.comentario} iTouched={touched.comentario} fIsSubmitting={isSubmitting} />
              <Divider title='Información Adicional' />
              <Row>
                <Col md={6}>
                  <FormaDePagoSunatFormGroup
                    iError={errors._idFormaDePagoSunat}
                    iTouched={touched._idFormaDePagoSunat}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
                <Col md={6}>
                  <CondicionesDePagoFormGroup iError={errors._idCondicionDePago} iTouched={touched._idCondicionDePago} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <MonedaFormGroup iError={errors.moneda} iTouched={touched.moneda} fIsSubmitting={isSubmitting} />
                </Col>
                <Col md={4}>
                  <LimiteCreditoFormGroup iError={errors.limiteCredito} iTouched={touched.limiteCredito} fIsSubmitting={isSubmitting} />
                </Col>
                <Col md={4}>
                  <MonedaLimiteCreditoFormGroup
                    iError={errors.monedaLimiteCredito}
                    iTouched={touched.monedaLimiteCredito}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <CuentaCorrienteSolesFormGroup
                    iError={errors.cuentaCorrienteSoles}
                    iTouched={touched.cuentaCorrienteSoles}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
                <Col md={4}>
                  <CuentaCorrienteDolaresFormGroup
                    iError={errors.cuentaCorrienteDolares}
                    iTouched={touched.cuentaCorrienteDolares}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              <Divider title='Información de Características' />
              <Row>
                <Col md={4}>
                  <FlagAgentePercepcionFormGroup iValue={values.flagAgentePercepcion} fIsSubmitting={isSubmitting} />
                </Col>
                <Col md={4}>
                  <FlagAgenteRetencionFormGroup iValue={values.flagAgenteRetencion} fIsSubmitting={isSubmitting} />
                </Col>
                <Col md={4}>
                  <FlagBuenContribuidorFormGroup iValue={values.flagBuenContribuidor} fIsSubmitting={isSubmitting} />
                </Col>
                <Col md={4}>
                  <FacturacionConIgvFormGroup iValue={values.facturacionConIgv} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Tabs defaultActiveKey='1' id='tabs-socios'>
                    <Tabs.Tab eventKey='1' title='Contactos'>
                      <ContactosSection contactos={contactos} dispatch={contactosDispatcher} />
                    </Tabs.Tab>
                    <Tabs.Tab eventKey='2' title='Direcciones'>
                      <DireccionesSection direcciones={direcciones} dispatch={direccionesDispatcher} />
                    </Tabs.Tab>
                    <Tabs.Tab eventKey='3' title='Placas'>
                      <PlacasSection placas={placas} dispatch={placasDispatcher} />
                    </Tabs.Tab>
                    <Tabs.Tab eventKey='4' title='Documentos'>
                      <DocumentosSection
                        documentos={documentos}
                        dispatch={documentosDispatcher}
                        idSocio={editarData._id}
                      />
                    </Tabs.Tab>
                  </Tabs>
                </Col>
              </Row>
              <Row className='mt-4'>
                <Col md={12} className='text-right'>
                  <RetrocederButton />
                  <Button onClick={handleSubmit} className='ml-2'>
                    Guardar
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Col>
    </Row>
  )
}

export default NuevoMainForm
